'use client'

import { useEffect, useState } from 'react'
import { Spacer } from '@vinted/web-ui'
import classNames from 'classnames'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { ProductItemModel } from '@marketplace-web/domain/product-item-data'
import { exposeCpThresholdAbTest, VasEntryPoint } from '@marketplace-web/vas/vas-data'

import ClosetPromotionCheckout from '../ClosetPromotion/ClosetPromotionCheckout'
import useVasEntryPointsContext from '../../containers/VasEntryPointsProvider/useVasEntryPointsContext'
import ClosetPromotionBanner from './ClosetPromotionBanner'
import BumpBanner from './BumpBanner'

type Props = {
  getSingleBumpableItem: () => ProductItemModel | undefined
}

const ProfileVasBanners = ({ getSingleBumpableItem }: Props) => {
  const breakpoints = useBreakpoint()
  const cpMinimumItemCount20AbTest = useAbTest('cp_minimum_item_count_20')

  const { vasEntryPoints } = useVasEntryPointsContext()

  const [isPrecheckoutOpen, setIsPrecheckoutOpen] = useState(false)

  useEffect(() => {
    if (!cpMinimumItemCount20AbTest) return

    exposeCpThresholdAbTest(VasEntryPoint.ProfilePromotedClosets)
  }, [cpMinimumItemCount20AbTest])

  function handlePrecheckoutOpen() {
    setIsPrecheckoutOpen(true)
  }

  function handlePrecheckoutClose() {
    setIsPrecheckoutOpen(false)
  }

  function renderSeparator() {
    return breakpoints.phones ? (
      <Spacer orientation={Spacer.Orientation.Horizontal} size={Spacer.Size.Medium} />
    ) : (
      <Spacer orientation={Spacer.Orientation.Vertical} size={Spacer.Size.XLarge} />
    )
  }

  const isPromotedClosetsCheckoutEntryPointAvailable = vasEntryPoints?.some(
    entryPoint => entryPoint.name === VasEntryPoint.ProfilePromotedClosets,
  )

  const promotedClosetsBanner = vasEntryPoints?.find(
    entryPoint =>
      entryPoint.name === VasEntryPoint.ProfilePromotedClosets ||
      entryPoint.name === VasEntryPoint.PromotedClosetsStats,
  )

  const bumpBanner = vasEntryPoints?.find(entryPoint => entryPoint.name === VasEntryPoint.Bumps)

  return (
    <>
      <div className={classNames({ 'u-flexbox': breakpoints.tabletsUp })}>
        <SeparatedList separator={renderSeparator()}>
          {bumpBanner && (
            <BumpBanner bumpBanner={bumpBanner} getSingleBumpableItem={getSingleBumpableItem} />
          )}
          {promotedClosetsBanner && (
            <ClosetPromotionBanner
              promotedClosetsBanner={promotedClosetsBanner}
              handlePrecheckoutOpen={handlePrecheckoutOpen}
            />
          )}
        </SeparatedList>
      </div>
      {isPromotedClosetsCheckoutEntryPointAvailable && (
        <ClosetPromotionCheckout
          isOpen={isPrecheckoutOpen}
          handlePrecheckoutClose={handlePrecheckoutClose}
        />
      )}
    </>
  )
}

export default ProfileVasBanners
